var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectbg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 1122,
    viewBox: "0 0 297 1122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.692 461.018C145.291 518.487 169.692 645.519 180.515 682.212C193.624 726.658 281.241 811.974 295.047 905.711C315.553 1044.93 169.692 1143.72 85.076 1117.88C-11.9611 1088.25 29.4835 912.709 29.4835 888.419C29.4835 871.873 55.0654 742.679 61.4608 717.872C66.4649 698.462 85.0761 576.247 85.0761 540.606C85.0761 491.51 50.1458 368.509 29.4835 331.299C8.82122 294.088 -18.2366 124.058 17.1844 62.0409C52.6055 0.02379 157.885 -20.6472 231.679 23.7984C305.472 68.244 271.975 220.832 258.736 244.475C243.978 270.832 200.194 389.181 169.692 461.018Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectbg2);
export default __webpack_public_path__ + "static/media/connectbg2.fd798f8c72d8a4e23ef6b6e7c408b632.svg";
export { ForwardRef as ReactComponent };